
import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import { UUIDContext } from "../UUIDContexted";
import CONSTANTS from "../utils/constants";
import { Container } from "react-bootstrap";

import errorCircle from "../assets/img/success-error-pages/error_circle.svg"
import "./Error.css";

const ErrorMessages: React.FC = () => {
  const pbld = useContext(UUIDContext);
  if (pbld?.status === 'EXPIRED') {
    return (
      <>
        <h1 className="volterounded-semibold message-l1" data-testid="errorPage-linkExpired-message">
          <FormattedMessage id={CONSTANTS.Error_PAGE.DISPLAY_MESSAGE.LINK_EXPIRED} defaultMessage="THE PAYMENT LINK HAS EXPIRED" />
        </h1>
        <h1 className="volterounded-semibold message-l2" data-testid="errorPage-contactSeller-message">
          <FormattedMessage id={CONSTANTS.Error_PAGE.DISPLAY_MESSAGE.CONTACT_SELLER} defaultMessage="Please get in touch with the Seller to receive a new payment link." />
        </h1>
      </>
    )
  } else {
    return (
      <>
        <h1 className="volterounded-semibold message-l1" data-testid="errorPage-sorry-message">
          <FormattedMessage id={CONSTANTS.Error_PAGE.DISPLAY_MESSAGE.SORRY_MESSAGE} defaultMessage="WE ARE SORRY!" />
        </h1>
        <h1 className="volterounded-semibold message-l2" data-testid="errorPage-errorOccured-message">
          <FormattedMessage id={CONSTANTS.Error_PAGE.DISPLAY_MESSAGE.ERROR_OCCURRED} defaultMessage="APPARENTLY AN ERROR HAS OCCURRED" />
        </h1>
      </>
    )
  }
}

export default function ErrorPage(){
  return(
    <>
    <Container>
      <div className="d-flex flex-column align-items-center position-absolute error-container">
        <div>
          <img src={errorCircle} className="error-circle" alt="Error Circle" data-testid="errorPage-error-circle" />
        </div>
        <div className="text-center error-msg">
          <ErrorMessages />
        </div>
      </div>
    </Container>
    </>
  )
}